import styled, { css } from "styled-components";
export const CardImageCap = styled.div `
  ${({ height }) => height &&
    css `
      height: ${height};
    `};

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;
